<template>
  <layer-page typeTitle="校正"></layer-page>
</template>

<script>
import layerPage from '../components/layerPage.vue'
export default {
  components: {
    layerPage
  }
}
</script>
